import { LayoutDataType } from '../../types';

export const OBEDIENCE_OPTIONS: {
  id: NonNullable<LayoutDataType['obedience']>;
  title: string;
}[] = [
  {
    id: 'challenge',
    title: 'Challenge',
  },
  {
    id: 'agree',
    title: 'Agree',
  },
];
